import { useContext } from '@berlin-front/common/composables/context';
import { BerlinBffContext } from '@services/BerlinBff';
import { readonly, reactive, unref, watch, ref, computed } from '@vue/composition-api';
import { useMutation } from 'vue-query';
import useOrAll from '@berlin-front/common/composables/useOrAll';
import { useRouter } from '@berlin-front/common/composables/useRouter';
import useCss from '@berlin-front/common/composables/useCss';
import { ApiCacheContext } from '@/services/ApiCacheContext';
import { broadcast } from '@/broadcast';
import { ROUTE_NAME } from '@/router/route-name';

export const useLoading = () => ({
  useLoading: () => {
    const router = useRouter();
    const { registTransactionPostResult, setRegistTransactionPostResult, npAtobaraiModalParameter } =
      useContext(ApiCacheContext);
    const { npAtobaraiTransaction } = useContext(BerlinBffContext);
    const completeProgress = ref(false);
    // 後払い中のローディングでは何も触らせない。
    useCss(
      () => /* css */ `
        body {
          user-select: none;
          pointer-events: none;
        }`,
    );

    const { mutate, isError, isSuccess } = useMutation(
      'npAtobaraiTransaction.TransactionPost',
      () =>
        npAtobaraiTransaction.npAtobaraiTransactionControllerRegistTransactionPost({
          shopPublicKey: npAtobaraiModalParameter.value.pubKey,
          terminalId: npAtobaraiModalParameter.value.terminalId,
          shopTransactionNo: npAtobaraiModalParameter.value.payment.shopTransactionNo,
          checksum: npAtobaraiModalParameter.value.payment.checksum,
          billOption: npAtobaraiModalParameter.value.payment.billOption,
          siteName: npAtobaraiModalParameter.value.payment.siteName,
          siteUrl: npAtobaraiModalParameter.value.payment.siteUrl,
          transactionOptions: npAtobaraiModalParameter.value.payment.transactionOptions,
          firstTransactionId: npAtobaraiModalParameter.value.payment.firstTransactionId,
          authoriOption: npAtobaraiModalParameter.value.payment.authoriOption,
          amount: npAtobaraiModalParameter.value.payment.amount,
          customer: npAtobaraiModalParameter.value.payment.customer,
          destCustomers: npAtobaraiModalParameter.value.payment.destCustomers,
          items: npAtobaraiModalParameter.value.payment.items,
          salesForm: npAtobaraiModalParameter.value.payment.salesForm,
          sourceMedia: npAtobaraiModalParameter.value.payment.sourceMedia,
        }),
      {
        onSuccess: ({ data }) => {
          // TODO: API治ったら修正する。
          setRegistTransactionPostResult(data);
        },
      },
    );

    mutate();

    watch(completeProgress, (complete) => {
      if (complete) {
        const result = unref(registTransactionPostResult);
        if (!result) {
          // 決済APIでエラーが発生したケースは無視。broadcastに従ってエラー画面に遷移するため。
          return;
        }
        if (result?.authorizationResult === '00') {
          broadcast.send({
            type: 'MODAL_CONTROL_SUCCEEDED',
            payload: {
              serviceType: '02',
            },
          });
        } else {
          void router.replace({ name: ROUTE_NAME.NP_ATOBARAI_FAIL_AUTH_NG });
        }
      }
    });

    // 処理の終了。
    const isCompleted = useOrAll(isError, isSuccess);
    const isLoading = computed(() => !unref(isCompleted));

    return readonly(
      reactive({
        title: '注文確定',
        onComplete: () => {
          completeProgress.value = true;
        },
        isLoading,
        isCompleted,
        duration: Number.parseInt(process.env.VUE_APP_API_TIMEOUT_NP_ATOBARAI_TRANSACTION, 10),
      }),
    );
  },
});
